import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const InlineNestedAlert = makeShortcode("InlineNestedAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" api="collect-launch-info" repeat="2" mdxType="Variant" />
    <p>{`The Android SDK automatically registers an `}<inlineCode parentName="p">{`Application.ActivityLifecycleCallbacks`}</inlineCode>{`and listens for `}<inlineCode parentName="p">{`onActivityResumed`}</inlineCode>{`. When an activity is resumed, SDK collects the data from the activity. Currently, it is being used in the following scenarios:`}</p>
    <ul>
      <li parentName="ul">{`Tracking deep link clickthrough`}</li>
      <li parentName="ul">{`Tracking push message clickthrough`}</li>
      <li parentName="ul">{`Tracking Local Notification clickthrough`}</li>
    </ul>
    <Variant platform="ios" api="collect-launch-info" repeat="14" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <p>{`This method should be called to support the following use cases:`}</p>
    <ul>
      <li parentName="ul">{`Tracking deep link clickthroughs`}
        <ul parentName="li">
          <li parentName="ul">{`From `}<inlineCode parentName="li">{`application(_:didFinishLaunchingWithOptions:)`}</inlineCode></li>
          <li parentName="ul">{`Extract `}<inlineCode parentName="li">{`userInfo`}</inlineCode>{` from `}<inlineCode parentName="li">{`url: UIApplication.LaunchOptionsKey`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ul">{`Tracking push message clickthrough`}
        <ul parentName="li">
          <li parentName="ul">{`From `}<inlineCode parentName="li">{`application(_:didReceiveRemoteNotification:fetchCompletionHandler:)`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` public static func collectLaunchInfo(_ userInfo: [String: Any])
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.collectLaunchInfo(userInfo)
`}</code></pre>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <p>{`This method should be called to support the following use cases:`}</p>
    <ul>
      <li parentName="ul">{`Tracking deep link clickthroughs`}
        <ul parentName="li">
          <li parentName="ul">{`From `}<inlineCode parentName="li">{`application:didFinishLaunchingWithOptions`}</inlineCode></li>
          <li parentName="ul">{`Extract `}<inlineCode parentName="li">{`userInfo`}</inlineCode>{` from `}<inlineCode parentName="li">{`UIApplicationLaunchOptionsURLKey`}</inlineCode>
            <ul parentName="li">
              <li parentName="ul">{`Tracking push message clickthrough`}</li>
            </ul>
          </li>
          <li parentName="ul">{`From `}<inlineCode parentName="li">{`application:didReceiveRemoteNotification:fetchCompletionHandler:`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(collectLaunchInfo:)
public static func collectLaunchInfo(_ userInfo: [String: Any])
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` [AEPMobileCore collectLaunchInfo:launchOptions];
`}</code></pre>
    <Variant platform="android" api="collect-pii" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void collectPii(@NonNull final Map<String, String> data)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Map<String, String> data = new HashMap<String, String>();
data.put("firstname", "customer");
//The rule to trigger a PII needs to be setup for this call
//to result in a network send
MobileCore.collectPii(data);
`}</code></pre>
    <Variant platform="ios" api="collect-pii" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func collectPii(_ data: [String: Any])
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`MobileCore.collectPii(["key1" : "value1","key2" : "value2"]);
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` @objc(collectPii:)
 public static func collectPii(_ data: [String: Any])
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{` [AEPMobileCore collectPii:data:@{@"key1" : @"value1",
                            @"key2" : @"value2"
                            }];
`}</code></pre>
    {/*- <Variant platform="react-native" api="collect-pii" repeat="10"/>
     #### Javascript
     **Syntax**
     ```jsx
     ACPCore.collectPii(data: [String : String])
     ```
     **Example**
     ```jsx
     ACPCore.collectPii({"myPii": "data"});
     ```
     #### Swift
     **Syntax**
     ```swift
     ACPCore.collectPii(data: [String : String])
     ```
     **Example**
     ```objectivec
     MobileCore.collectPii(["key1" : "value1","key2" : "value2"]);
     ``` -*/}
    <Variant platform="android" api="dispatch-event" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void dispatchEvent(@NonNull final Event event)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`final Map<String, Object> eventData = new HashMap<>();
eventData.put("sampleKey", "sampleValue");

final Event sampleEvent = new Event.Builder("SampleEventName", "SampleEventType", "SampleEventSource")
                          .setEventData(eventData)
                          .build();

MobileCore.dispatchEvent(sampleEvent);
`}</code></pre>
    <Variant platform="ios" api="dispatch-event" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-2"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func dispatch(event: Event)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let event = Event(name: "Sample Event Name", type: EventType.custom, source: EventType.custom, data: ["sampleKey": "sampleValue"])
MobileCore.dispatch(event: event)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-2"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`@objc(dispatch:)
public static func dispatch(event: Event)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`AEPEvent *event = [[AEPEvent alloc] initWithName:@"Sample Event Name" type:AEPEventType.custom source:AEPEventType.custom data:@{@"sampleKey": @"sampleValue"}];
[AEPMobileCore dispatch:event];
`}</code></pre>
    <Variant platform="android" api="dispatch-event-with-response-callback" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-2"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void dispatchEventWithResponseCallback(@NonNull final Event event, final long timeoutMS, @NonNull final AdobeCallbackWithError<Event> responseCallback)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`final Map<String, Object> eventData = new HashMap<>();
eventData.put("sampleKey", "sampleValue");

final Event sampleEvent = new Event.Builder("My Event", "SampleEventType", "SampleEventSource")
                          .setEventData(eventData)
                          .build();

MobileCore.dispatchEventWithResponseCallback(sampleEvent, 5000L, new AdobeCallbackWithError<Event>() {
    // handle response event
});
`}</code></pre>
    <Variant platform="ios" api="dispatch-event-with-response-callback" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-3"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func dispatch(event: Event, timeout: TimeInterval = 1, responseCallback: @escaping (Event?) -> Void)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`let event = Event(name: "My Event", type: EventType.custom, source: EventType.custom, data: ["sampleKey": "sampleValue"])
MobileCore.dispatch(event: event) { (responseEvent) in
    // handle responseEvent
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-3"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`@objc(dispatch:timeout:responseCallback:)
public static func dispatch(event: Event, timeout: TimeInterval = 1, responseCallback: @escaping (Event?) -> Void)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`AEPEvent *event = [[AEPEvent alloc] initWithName:@"My Event" type:AEPEventType.custom source:AEPEventType.custom data:@{@"sampleKey": @"sampleValue"}];
[AEPMobileCore dispatch:event responseCallback:^(AEPEvent * _Nullable responseEvent) {
    // handle responseEvent
}];
`}</code></pre>
    <Variant platform="android" api="get-application" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-3"
    }}>{`Java`}</h4>
    <p><inlineCode parentName="p">{`MobileCore.getApplication`}</inlineCode>{` will return `}<inlineCode parentName="p">{`null`}</inlineCode>{` if the `}<inlineCode parentName="p">{`Application`}</inlineCode>{` object was destroyed or if `}<inlineCode parentName="p">{`MobileCore.setApplication`}</inlineCode>{` was not previously called.`}</p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@Nullable
public static Application getApplication()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Application app = MobileCore.getApplication();
if (app != null) {
    ...
}
`}</code></pre>
    <Variant platform="android" api="get-log-level" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-4"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`@NonNull
public static LoggingMode getLogLevel()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`LoggingMode mode = MobileCore.getLogLevel();
`}</code></pre>
    <Variant platform="ios" api="get-log-level" repeat="12" mdxType="Variant" />
    <p>{`The logLevel getter has been deprecated. To get the log level in the Swift AEP 3.x SDKs, please use `}<inlineCode parentName="p">{`Log.logFilter`}</inlineCode>{` instead.`}</p>
    <h4 {...{
      "id": "swift-4"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static var logFilter: LogLevel
`}</code></pre>
    <p>{`This variable is part of the `}<inlineCode parentName="p">{`Log`}</inlineCode>{` class within `}<inlineCode parentName="p">{`AEPServices`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`var logLevel = Log.logFilter
`}</code></pre>
    <h4 {...{
      "id": "objective-c-4"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`@objc public static var logFilter: LogLevel
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`AEPLogLevel logLevel = [AEPLog logFilter];
`}</code></pre>
    {/*- <Variant platform="react-native" api="get-log-level" repeat="3"/>
     #### Javascript
     **Example**
     ```jsx
     ACPCore.getLogLevel().then(level => console.log("AdobeExperienceSDK: Log Level = " + level));
     ``` -*/}
    <Variant platform="android" api="get-sdk-identities" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-5"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`void getSdkIdentities(@NonNull AdobeCallback<String> callback);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the SDK identities as a JSON string. If an instance of  `}<inlineCode parentName="li">{`AdobeCallbackWithError`}</inlineCode>{` is provided, and you are fetching the attributes from the Mobile SDK, the timeout value is 5000ms. If the operation times out or an unexpected error occurs, the `}<inlineCode parentName="li">{`fail`}</inlineCode>{` method is called with the appropriate `}<inlineCode parentName="li">{`AdobeError`}</inlineCode>{`.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.getSdkIdentities(new AdobeCallback<String>() {
    @Override
    public void call(String value) {
        // handle the json string
    }
});
`}</code></pre>
    <Variant platform="ios" api="get-sdk-identities" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-5"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func getSdkIdentities(completion: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the SDK identities as a JSON string.`}</li>
      <li parentName="ul"><em parentName="li">{`completionHandler`}</em>{` is invoked with the SDK identities as a JSON string, or `}<em parentName="li">{`error`}</em>{` if an unexpected error occurs or the request times out. The default timeout is 1000ms.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.getSdkIdentities { (content, error) in
     // handle completion
 }
`}</code></pre>
    <h4 {...{
      "id": "objective-c-5"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{` @objc(getSdkIdentities:)
 static func getSdkIdentities(completion: @escaping (String?, Error?) -> Void)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`callback`}</em>{` is invoked with the SDK identities as a JSON string.`}</li>
      <li parentName="ul"><em parentName="li">{`completionHandler`}</em>{` is invoked with the SDK identities as a JSON string, or `}<em parentName="li">{`error`}</em>{` if an unexpected error occurs or the request times out. The default timeout is 1000ms.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{` [AEPMobileCore getSdkIdentities:^(NSString * _Nullable content, NSError * _Nullable error) {
     if (error) {
       // handle error here
     } else {
       // handle the retrieved identities
     }
 }];
`}</code></pre>
    <Variant platform="android" api="initialize-appid" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-6"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` public static void initialize(
            @NonNull final Application application,
            @NonNull final String appId,
            @Nullable final AdobeCallback<?> completionCallback) 
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`application`}</em>{` The Android Application instance.`}</li>
      <li parentName="ul"><em parentName="li">{`appID`}</em>{` The mobile property environment ID configured from the Data Collection UI.`}</li>
      <li parentName="ul"><em parentName="li">{`completionCallback`}</em>{` An Optional `}<a parentName="li" {...{
          "href": "#adobecallback"
        }}>{`AdobeCallback`}</a>{` triggered once initialization is complete.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class CoreApp extends Application {
   @Override
   public void onCreate() {
      super.onCreate();
      MobileCore.initialize(this, "ENVIRONMENT_ID", o -> {
          Log.d(LOG_TAG, "AEP Mobile SDK is initialized");
      });
   }
}
`}</code></pre>
    <Variant platform="ios" api="initialize-appid" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-6"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func initialize(appId: String, _ completion: (() -> Void)? = nil)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`appId`}</em>{` The mobile property environment ID configured from the Data Collection UI.`}</li>
      <li parentName="ul"><em parentName="li">{`completion`}</em>{` An Optional callback triggered once initialization is complete.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// AppDelegate.swift
func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
  MobileCore.initialize(appId: "ENVIRONMENT_ID") {
      print("AEP Mobile SDK is initialized")
  }
  ...
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-6"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(initializeWithAppId:completion:)
public static func initialize(appId: String, _ completion: (() -> Void)? = nil) 
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`appId`}</em>{` The mobile property environment ID configured from the Data Collection UI.`}</li>
      <li parentName="ul"><em parentName="li">{`completion`}</em>{` An Optional callback triggered once initialization is complete.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`// AppDelegate.m
- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
  [AEPMobileCore initializeWithAppId:@"ENVIRONMENT_ID" completion:^{
      NSLog(@"AEP Mobile SDK is initialized");
  }];
  ...
}
`}</code></pre>
    <Variant platform="android" api="initialize-initoptions" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-7"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void initialize(
            @NonNull final Application application,
            @NonNull final InitOptions initOptions,
            @Nullable final AdobeCallback<?> completionCallback)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`application`}</em>{` The Android Application instance.`}</li>
      <li parentName="ul"><em parentName="li">{`initOptions`}</em>{` The `}<a parentName="li" {...{
          "href": "#initoptions"
        }}>{`InitOptions`}</a>{` to configure the SDK.`}</li>
      <li parentName="ul"><em parentName="li">{`completionCallback`}</em>{` An Optional `}<a parentName="li" {...{
          "href": "#adobecallback"
        }}>{`AdobeCallback`}</a>{` triggered once initialization is complete.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class CoreApp extends Application {
   @Override
   public void onCreate() {
      super.onCreate();

      // Use InitOptions to disable automatic lifecycle tracking.
      InitOptions initOptions = InitOptions.configureWithAppID("ENVIRONMENT_ID")
      initOptions.lifecycleAutomaticTrackingEnabled = false
      MobileCore.initialize(this, initOptions, o -> {
          Log.d(LOG_TAG, "AEP Mobile SDK is initialized");
      });
   }
}
`}</code></pre>
    <Variant platform="ios" api="initialize-initoptions" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-7"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func initialize(options: InitOptions, _ completion: (() -> Void)? = nil)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`options`}</em>{` The `}<a parentName="li" {...{
          "href": "#initoptions"
        }}>{`InitOptions`}</a>{` to configure the SDK.`}</li>
      <li parentName="ul"><em parentName="li">{`completion`}</em>{` An Optional callback triggered once initialization is complete.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// AppDelegate.swift
func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
  // Use InitOptions to disable automatic lifecycle tracking.
  let options = InitOptions(appId: "ENVIRONMENT_ID")
  options.lifecycleAutomaticTrackingEnabled = false

  MobileCore.initialize(options: options) {
      print("AEP Mobile SDK is initialized")
  }
  ...
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-7"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(initializeWithOptions:completion:)
public static func initialize(options: InitOptions, _ completion: (() -> Void)? = nil)        
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`options`}</em>{` The `}<a parentName="li" {...{
          "href": "#initoptions"
        }}>{`InitOptions`}</a>{` to configure the SDK.`}</li>
      <li parentName="ul"><em parentName="li">{`completion`}</em>{` An Optional callback triggered once initialization is complete.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`// AppDelegate.m
- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    // Use InitOptions to disable automatic lifecycle tracking.
    AEPInitOptions *options = [[AEPInitOptions alloc] initWithAppId:@"ENVIRONMENT_ID"];
    options.lifecycleAutomaticTrackingEnabled = NO;

    [AEPMobileCore initializeWithOptions:options completion:^{
        NSLog(@"AEP Mobile SDK is initialized");
    }];
    ...
}
`}</code></pre>
    <Variant platform="android" api="log" repeat="11" mdxType="Variant" />
    <p>{`This API was deprecated in v2.0.0 of the Mobile Core extension. Use the `}<inlineCode parentName="p">{`com.adobe.marketing.mobile.services.Log`}</inlineCode>{` instead.`}</p>
    <h4 {...{
      "id": "java-8"
    }}>{`Java`}</h4>
    <p>{`The `}<inlineCode parentName="p">{`MobileCore`}</inlineCode>{` logging APIs use the `}<inlineCode parentName="p">{`android.util.Log`}</inlineCode>{` APIs to log messages to Android. Based on the `}<inlineCode parentName="p">{`LoggingMode`}</inlineCode>{` that is passed to `}<inlineCode parentName="p">{`MobileCore.log()`}</inlineCode>{`, the following Android method is called:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`LoggingMode.VERBOSE`}</inlineCode>{` uses `}<inlineCode parentName="li">{`android.util.Log.v`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`LoggingMode.DEBUG`}</inlineCode>{` uses `}<inlineCode parentName="li">{`android.util.Log.d`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`LoggingMode.WARNING`}</inlineCode>{` uses `}<inlineCode parentName="li">{`android.util.Log.w`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`LoggingMode.ERROR`}</inlineCode>{` uses `}<inlineCode parentName="li">{`android.util.Log.e`}</inlineCode></li>
    </ul>
    <p>{`All log messages from the Adobe Experience SDK to Android use the same log tag of `}<inlineCode parentName="p">{`AdobeExperienceSDK`}</inlineCode>{`. For example, if logging an error message is using `}<inlineCode parentName="p">{`MobileCore.log()`}</inlineCode>{`, the call to `}<inlineCode parentName="p">{`android.util.Log.e`}</inlineCode>{` looks like `}<inlineCode parentName="p">{`Log.e("AdobeExperienceSDK", tag + " - " + message)`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void log(final LoggingMode mode, final String tag, final String message)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.log(LoggingMode.DEBUG, "MyClassName", "Provided data was null");
`}</code></pre>
    <p><strong parentName="p">{`Output`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-text"
      }}>{`D/AdobeExperienceSDK: MyClassName - Provided data was null
`}</code></pre>
    <Variant platform="ios" api="log" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-8"
    }}>{`Swift`}</h4>
    <p>{`The log messages from the Adobe Experience SDK are printed to the Apple System Log facility and use a common format that contains the tag `}<inlineCode parentName="p">{`AEP SDK`}</inlineCode>{`. For example, if logging an error message using `}<inlineCode parentName="p">{`Log.error(label:_ message:_)`}</inlineCode>{`, the printed output looks like `}<inlineCode parentName="p">{`[AEP SDK ERROR <label>]: message`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func trace(label: String, _ message: String) {
public static func debug(label: String, _ message: String)
public static func warning(label: String, _ message: String) {
public static func error(label: String, _ message: String) {
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`Log.trace(label: "testLabel", "Test message")
Log.debug(label: "testLabel", "Test message")
Log.warning(label: "testLabel", "Test message")
Log.error(label: "testLabel", "Test message")
`}</code></pre>
    <h4 {...{
      "id": "objective-c-8"
    }}>{`Objective-C`}</h4>
    <p>{`The log messages from the Adobe Experience SDK are printed to the Apple System Log facility and use a common format that contains the tag `}<inlineCode parentName="p">{`AEP SDK`}</inlineCode>{`. For example, if logging an error message using `}<inlineCode parentName="p">{`[AEPLog errorWithLabel: _ message:_]`}</inlineCode>{`, the printed output looks like `}<inlineCode parentName="p">{`[AEP SDK ERROR <label>]: message`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@objc(traceWithLabel:message:)
public static func trace(label: String, _ message: String)

@objc(debugWithLabel:message:)
public static func debug(label: String, _ message: String)

@objc(warningWithLabel:message:)
public static func warning(label: String, _ message: String)

@objc(errorWithLabel:message:)
public static func error(label: String, _ message: String)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPLog traceWithLabel:@"testLabel" message:@"testMessage"];
[AEPLog debugWithLabel:@"testLabel" message:@"testMessage"];
[AEPLog warningWithLabel:@"testLabel" message:@"testMessage"];
[AEPLog errorWithLabel:@"testLabel" message:@"testMessage"];
`}</code></pre>
    {/*- <Variant platform="react-native" api="log" repeat="6"/>
     #### JavaScript
     The log messages from the Adobe Experience SDK are printed to the Log facility and use a common format that contains the tag `ACPMobileLogLevel`.
     **Example**
     ```jsx
     ACPCore.log(ACPMobileLogLevel.ERROR, "React Native Tag", "React Native Message");
     ```
     Note: `ACPMobileLogLevel` contains the following getters:
     ```jsx
     const ERROR = "ACP_LOG_LEVEL_ERROR";
     const WARNING = "ACP_LOG_LEVEL_WARNING";
     const DEBUG = "ACP_LOG_LEVEL_DEBUG";
     const VERBOSE = "ACP_LOG_LEVEL_VERBOSE";
     ``` -*/}
    <Variant platform="android" api="register-event-listener" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-9"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void registerEventListener(@NonNull final String eventType, @NonNull final String eventSource, @NonNull final AdobeCallback<Event> callback)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.registerEventListener(EventType.CONFIGURATION, EventSource.RESPONSE_CONTENT, new AdobeCallback<Event>() {
    @Override
    public void call(Event value) {
        // handle event
    }
});
`}</code></pre>
    <Variant platform="ios" api="register-event-listener" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-9"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func registerEventListener(type: String, source: String, listener: @escaping EventListener)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.registerEventListener(type: EventType.configuration, source: EventSource.responseContent, listener: { event in
   // handle event
})
`}</code></pre>
    <h4 {...{
      "id": "objective-c-9"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(registerEventListenerWithType:source:listener:)
public static func registerEventListener(type: String, source: String, listener: @escaping EventListener)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileCore registerEventListenerWithType: type source: source listener:^(AEPEvent * _Nonnull event) {
   // handle event
}];
`}</code></pre>
    <Variant platform="android" api="register-extension" repeat="6" mdxType="Variant" />
    <InlineNestedAlert variant="warning" header="true" iconPosition="left" mdxType="InlineNestedAlert">
      <p>{`This API has been deprecated starting in v2.0.0 and removed in v3.0.0 of Mobile Core extension.`}</p>
      <p>{`Use `}<a parentName="p" {...{
          "href": "#registerextensions"
        }}>{`registerExtensions`}</a>{` to register desired extensions and boot up the SDK for event processing. Calling `}<inlineCode parentName="p">{`MobileCore.start()`}</inlineCode>{` API is no longer required when using `}<inlineCode parentName="p">{`MobileCore.registerExtensions()`}</inlineCode>{`.`}</p>
    </InlineNestedAlert>
    <h4 {...{
      "id": "java-10"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static boolean registerExtension(@NonNull final Class<? extends Extension> extensionClass, @Nullable final ExtensionErrorCallback<ExtensionError> errorCallback)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.registerExtension(Signal.EXTENSION, errorCallback -> {
  // handle callback                   
});
`}</code></pre>
    <Variant platform="ios" api="register-extension" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-10"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func registerExtension(_ exten: Extension.Type, _ completion: (() -> Void)? = nil)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.registerExtension(Lifecycle.self) {
    // handle completion
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-10"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(registerExtension:completion:)
public static func registerExtension(_ exten: Extension.Type, _ completion: (() -> Void)? = nil)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileCore registerExtension:AEPMobileLifecycle.class completion:^{
   // handle completion
}];
`}</code></pre>
    <Variant platform="android" api="register-extensions" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-11"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void registerExtensions(@NonNull final List<Class<? extends Extension>> extensions, @Nullable final AdobeCallback<?> completionCallback)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.AdobeCallback;
import com.adobe.marketing.mobile.Edge;
import com.adobe.marketing.mobile.edge.consent.Consent;
import com.adobe.marketing.mobile.edge.identity.Identity;
import com.adobe.marketing.mobile.Lifecycle;
import com.adobe.marketing.mobile.LoggingMode;
import com.adobe.marketing.mobile.MobileCore;
import com.adobe.marketing.mobile.Signal;
import com.adobe.marketing.mobile.UserProfile;
...
import android.app.Application;
...
public class MainApp extends Application {

    // Set up the preferred Environment File ID from your mobile property configured in Data Collection UI
    private static final String ENVIRONMENT_FILE_ID = "YOUR_ENVIRONMENT_FILE_ID";

    @Override
    public void onCreate() {
        super.onCreate();

        MobileCore.setApplication(this);
        MobileCore.configureWithAppID(ENVIRONMENT_FILE_ID);

        List<Class<? extends Extension>> extensions = Arrays.asList(
                Lifecycle.EXTENSION,
                Signal.EXTENSION,
                UserProfile.EXTENSION
                Edge.EXTENSION,
                Consent.EXTENSION,
                EdgeIdentity.EXTENSION);
        MobileCore.registerExtensions(extensions, o -> {
            Log.d(LOG_TAG, "AEP Mobile SDK is initialized");
        });
    }
}
`}</code></pre>
    <Variant platform="ios" api="register-extensions" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-11"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func registerExtensions(_ extensions: [NSObject.Type], _ completion: (() -> Void)? = nil)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// AppDelegate.swift
func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
    MobileCore.registerExtensions([Signal.self, Lifecycle.self, UserProfile.self, Edge.self, AEPEdgeIdentity.Identity.self, Consent.self], {
        MobileCore.configureWith(appId: "yourAppId")
    })
  ...
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-11"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(registerExtensions:completion:)
public static func registerExtensions(_ extensions: [NSObject.Type], _ completion: (() -> Void)? = nil)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`// AppDelegate.m
- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
    [AEPMobileCore registerExtensions:@[AEPMobileSignal.class, AEPMobileLifecycle.class, AEPMobileUserProfile.class, AEPMobileEdge.class, AEPMobileEdgeIdentity.class, AEPMobileEdgeConsent.class] completion:^{
    [AEPMobileCore configureWithAppId: @"yourAppId"];
  }];
  ...
}
`}</code></pre>
    {/*- <Variant platform="react-native" api="register-extension" repeat="5"/>
     For React Native apps, initialize the SDK using native code in your `AppDelegate` (iOS) and `MainApplication` (Android).
     #### iOS
     ```objectivec
     #import "ACPCore.h"
     #import "ACPUserProfile.h"
     #import "ACPIdentity.h"
     #import "ACPLifecycle.h"
     #import "ACPSignal.h"
     ...
     @implementation AppDelegate
     -(BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
        [ACPCore setLogLevel:ACPMobileLogLevelDebug];
        [ACPCore configureWithAppId:@"<your_environment_id_from_Launch>"];
        [ACPUserProfile registerExtension];
        [ACPIdentity registerExtension];
        [ACPLifecycle registerExtension];
        [ACPSignal registerExtension];
         const UIApplicationState appState = application.applicationState;
        [ACPCore start:^{
          // only start lifecycle if the application is not in the background
          if (appState != UIApplicationStateBackground) {
            [ACPCore lifecycleStart:nil];
          }
        }];
        ...
      return YES;
     }
     @end
     ```
     #### Android
     ```java
     import com.adobe.marketing.mobile.AdobeCallback;
     import com.adobe.marketing.mobile.Identity;
     import com.adobe.marketing.mobile.InvalidInitException;
     import com.adobe.marketing.mobile.Lifecycle;
     import com.adobe.marketing.mobile.LoggingMode;
     import com.adobe.marketing.mobile.MobileCore;
     import com.adobe.marketing.mobile.Signal;
     import com.adobe.marketing.mobile.UserProfile;
     ...
     import android.app.Application;
     ...
     public class MainApplication extends Application implements ReactApplication {
      ...
      @Override
      public void onCreate(){
        super.onCreate();
        ...
        MobileCore.setApplication(this);
        MobileCore.setLogLevel(LoggingMode.DEBUG);
        MobileCore.setWrapperType(WrapperType.REACT_NATIVE);
         try {
          UserProfile.registerExtension();
          Identity.registerExtension();
          Lifecycle.registerExtension();
          Signal.registerExtension();
          MobileCore.start(new AdobeCallback () {
              @Override
              public void call(Object o) {
                MobileCore.configureWithAppID("<your_environment_id_from_Launch>");
             }
          });
        } catch (InvalidInitException e) {
          ...
        }
      }
     }
     ```
     <Variant platform="flutter" api="register-extension" repeat="3"/>
     #### Dart
     For Flutter apps, initialize the SDK using native code in your `AppDelegate` and `MainApplication` in iOS and Android, respectively.
     The initialization code is located in the [Flutter ACPCore Github README](https://github.com/adobe/flutter_acpcore). -*/}
    <Variant platform="android" api="reset-identities" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-12"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`void resetIdentities();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.resetIdentities();
`}</code></pre>
    <Variant platform="ios" api="reset-identities" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-12"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`static func resetIdentities()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.resetIdentities()
`}</code></pre>
    <h4 {...{
      "id": "objective-c-12"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`@objc(resetIdentities)
static func resetIdentities()
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileCore resetIdentities];
`}</code></pre>
    <Variant platform="ios" api="set-app-group" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-13"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func setAppGroup(_ group: String?)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.setAppGroup("appGroupId")
`}</code></pre>
    <h4 {...{
      "id": "objective-c-13"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`@objc(setAppGroup:)
public static func setAppGroup(_ group: String?)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileCore setAppGroup:@"app-group-id"];
`}</code></pre>
    <Variant platform="android" api="set-application" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-13"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void setApplication(@NonNull final Application app)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public class CoreApp extends Application {

   @Override
   public void onCreate() {
      super.onCreate();
      MobileCore.setApplication(this);

      List<Class<? extends Extension>> extensions = Arrays.asList(
                Lifecycle.EXTENSION, Signal.EXTENSION, UserProfile.EXTENSION...);
      MobileCore.registerExtensions(extensions, o -> {
          Log.d(LOG_TAG, "AEP Mobile SDK is initialized");
      });
   }
}
`}</code></pre>
    <Variant platform="android" api="set-log-level" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-14"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void setLogLevel(@NonNull LoggingMode mode)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.LoggingMode;
import com.adobe.marketing.mobile.MobileCore;

MobileCore.setLogLevel(LoggingMode.VERBOSE);
`}</code></pre>
    <Variant platform="ios" api="set-log-level" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-14"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` public static func setLogLevel(_ level: LogLevel)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`import AEPCore
import AEPServices

  MobileCore.setLogLevel(.trace)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-14"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` @objc(setLogLevel:)
 public static func setLogLevel(_ level: LogLevel)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`@import AEPCore;
@import AEPServices;

 [AEPMobileCore setLogLevel: AEPLogLevelTrace];
`}</code></pre>
    {/*- <Variant platform="react-native" api="set-log-level" repeat="5"/>
     #### Javascript
     **Syntax**
     ```jsx
     (void) setLogLevel: (ACPMobileLogLevel) logLevel;
     ```
     **Example**
     ```jsx
     import {ACPMobileLogLevel} from '@adobe/react-native-acpcore';
     ACPCore.setLogLevel(ACPMobileLogLevel.VERBOSE);
     ```
     <Variant platform="flutter" api="set-log-level" repeat="5"/>
     #### Dart
     **Syntax**
     ```dart
     (void) setLogLevel: (ACPMobileLogLevel) logLevel;
     ```
     **Example**
     ```dart
     import 'package:flutter_acpcore/src/acpmobile_logging_level.dart';
     FlutterACPCore.setLogLevel(ACPLoggingLevel.VERBOSE);
     ``` -*/}
    <Variant platform="android" api="set-push-identifier" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-15"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void setPushIdentifier(@Nullable final String pushIdentifier);
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`pushIdentifier`}</em>{`  is a string that contains the device token for push notifications.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`//Retrieve the token from either GCM or FCM, and pass it to the SDK
MobileCore.setPushIdentifier(token);
`}</code></pre>
    <Variant platform="ios" api="set-push-identifier" repeat="10" mdxType="Variant" />
    <h4 {...{
      "id": "swift-15"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func setPushIdentifier(_ deviceToken: Data?)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.setPushIdentifier(deviceToken)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-15"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` @objc(setPushIdentifier:)
 public static func setPushIdentifier(_ deviceToken: Data?)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{` [AEPMobileCore setPushIdentifier:deviceToken];
`}</code></pre>
    <Variant platform="android" api="set-icon-resource-id" repeat="11" mdxType="Variant" />
    <h4 {...{
      "id": "java-16"
    }}>{`Java`}</h4>
    <h4 {...{
      "id": "setsmalliconresourceid"
    }}>{`setSmallIconResourceID`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void setSmallIconResourceID(int resourceID)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` MobileCore.setSmallIconResourceID(R.mipmap.ic_launcher_round);
`}</code></pre>
    <h4 {...{
      "id": "setlargeiconresourceid"
    }}>{`setLargeIconResourceID`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void setLargeIconResourceID(int resourceID)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{` MobileCore.setLargeIconResourceID(R.mipmap.ic_launcher_round);
`}</code></pre>
    <Variant platform="android" api="set-wrapper-type" repeat="6" mdxType="Variant" />
    <p>{`The wrapper type can be set to one of the follwing types: `}<inlineCode parentName="p">{`NONE`}</inlineCode>{`, `}<inlineCode parentName="p">{`REACT_NATIVE`}</inlineCode>{`, `}<inlineCode parentName="p">{`FLUTTER`}</inlineCode>{`, `}<inlineCode parentName="p">{`CORDOVA`}</inlineCode>{`, `}<inlineCode parentName="p">{`UNITY`}</inlineCode>{`, `}<inlineCode parentName="p">{`XAMARIN`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "java-17"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void setWrapperType(@NonNull final WrapperType wrapperType)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.setWrapperType(WrapperType.REACT_NATIVE);
`}</code></pre>
    <Variant platform="ios" api="set-wrapper-type" repeat="11" mdxType="Variant" />
    <p>{`The wrapper type can be set to one of the follwing types: `}<inlineCode parentName="p">{`none`}</inlineCode>{`, `}<inlineCode parentName="p">{`reactNative`}</inlineCode>{`, `}<inlineCode parentName="p">{`flutter`}</inlineCode>{`, `}<inlineCode parentName="p">{`cordova`}</inlineCode>{`, `}<inlineCode parentName="p">{`unity`}</inlineCode>{`, `}<inlineCode parentName="p">{`xamarin`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "swift-16"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`public static func setWrapperType(_ type: WrapperType)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.setWrapperType(.flutter)
`}</code></pre>
    <h4 {...{
      "id": "objective-c-16"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{`@objc(setWrapperType:)
public static func setWrapperType(_ type: WrapperType)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileCore setWrapperType:AEPWrapperTypeFlutter];
`}</code></pre>
    <Variant platform="android" api="start" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-18"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void start(@Nullable final AdobeCallback<?> completionCallback)
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.AdobeCallback;
import com.adobe.marketing.mobile.Lifecycle;
import com.adobe.marketing.mobile.LoggingMode;
import com.adobe.marketing.mobile.MobileCore;
import com.adobe.marketing.mobile.Signal;
import com.adobe.marketing.mobile.UserProfile;
...
import android.app.Application;
...
public class MyApp extends Application {
  ...
  @Override
  public void onCreate(){
    super.onCreate();

    MobileCore.setApplication(this);

    UserProfile.registerExtension();
    Lifecycle.registerExtension();
    Signal.registerExtension();
    MobileCore.start(new AdobeCallback () {
        @Override
        public void call(Object o) {
          // implement callback
        }
    });
  }
}
`}</code></pre>
    <Variant platform="android" api="track-action" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-19"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void trackAction(@NonNull final String action, @Nullable final Map<String, String> contextData)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`action`}</em>{` contains the name of the action to track.`}</li>
      <li parentName="ul"><em parentName="li">{`contextData`}</em>{` contains the context data to attach on the hit.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Map<String, String> additionalContextData = new HashMap<String, String>();
additionalContextData.put("customKey", "value");
MobileCore.trackAction("loginClicked", additionalContextData);
`}</code></pre>
    <Variant platform="ios" api="track-action" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-17"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` static func track(action: String?, data: [String: Any]?)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`action`}</em>{` contains the name of the action to track.`}</li>
      <li parentName="ul"><em parentName="li">{`contextData`}</em>{` contains the context data to attach on this hit.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.track(action: "action name", data: ["key": "value"])
`}</code></pre>
    <h4 {...{
      "id": "objective-c-17"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` @objc(trackAction:data:)
 static func track(action: String?, data: [String: Any]?)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`action`}</em>{` contains the name of the action to track.`}</li>
      <li parentName="ul"><em parentName="li">{`contextData`}</em>{` contains the context data to attach on this hit.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`  [AEPMobileCore trackAction:@"action name" data:@{@"key":@"value"}];
`}</code></pre>
    {/*- <Variant platform="react-native" api="track-action" repeat="6"/>
     #### Javascript
     **Syntax**
     ```jsx
     trackAction(action?: String, contextData?: { string: string });
     ```
     * _action_ contains the name of the action to track.
     * _contextData_ contains the context data to attach on the hit.
     **Example**
     ```jsx
     ACPCore.trackAction("action name", {"key": "value"});
     ```
     <Variant platform="flutter" api="track-action" repeat="6"/>
     #### Dart
     **Syntax**
     ```dart
     Future<void> trackAction (String action, {Map<String, String> contextData});
     ```
     * _action_ contains the name of the action to track.
     * _contextData_ contains the context data to attach on the hit.
     **Example**
     ```dart
     FlutterACPCore.trackAction("action name",  data: {"key": "value"});
     ``` -*/}
    <Variant platform="android" api="track-state" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "java-20"
    }}>{`Java`}</h4>
    <p>{`In Android, `}<inlineCode parentName="p">{`trackState`}</inlineCode>{` is typically called every time a new `}<inlineCode parentName="p">{`Activity`}</inlineCode>{` is loaded.`}</p>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public static void trackState(@NonNull final String state, @Nullable final Map<String, String> contextData)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`state`}</em>{` contains the name of the state to track.`}</li>
      <li parentName="ul"><em parentName="li">{`contextData`}</em>{` contains the context data to attach on the hit.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`Map<String, String> additionalContextData = new HashMap<String, String>();        
additionalContextData.put("customKey", "value");
MobileCore.trackState("homePage", additionalContextData);
`}</code></pre>
    <Variant platform="ios" api="track-state" repeat="12" mdxType="Variant" />
    <h4 {...{
      "id": "swift-18"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` static func track(state: String?, data: [String: Any]?)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`state`}</em>{` contains the name of the state to track.`}</li>
      <li parentName="ul"><em parentName="li">{`contextData`}</em>{` contains the context data to attach on this hit.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{` MobileCore.track(state: "state name", data: ["key": "value"])
`}</code></pre>
    <h4 {...{
      "id": "objective-c-18"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objc"
      }}>{` @objc(trackState:data:)
 static func track(state: String?, data: [String: Any]?)
`}</code></pre>
    <ul>
      <li parentName="ul"><em parentName="li">{`state`}</em>{` contains the name of the state to track.`}</li>
      <li parentName="ul"><em parentName="li">{`contextData`}</em>{` contains the context data to attach on this hit.`}</li>
    </ul>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`  [AEPMobileCore trackState:@"state name" data:@{@"key":@"value"}];
`}</code></pre>
    {/*- <Variant platform="react-native" api="track-state" repeat="6"/>
     #### Javascript
     **Syntax**
     ```jsx
     trackState(state?: String, contextData?: { string: string });
     ```
     * _state_ contains the name of the state to track.
     * _contextData_ contains the context data to attach on the hit.
     **Example**
     ```jsx
     ACPCore.trackState("state name", {"key": "value"});
     ```
     <Variant platform="flutter" api="track-state" repeat="6"/>
     #### Dart
     **Syntax**
     ```dart
     Future<void> trackState (String state, {Map<String, String> contextData});
     ```
     * _state_ contains the name of the state to track.
     * _contextData_ contains the context data to attach on the hit.
     **Example**
     ```dart
     FlutterACPCore.trackState("state name",  data: {"key1: "value"})
     ``` -*/}
    <Variant platform="android" api="adobe-callback" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "java-21"
    }}>{`Java`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public interface AdobeCallback<T> {    
    void call(final T value);
}
`}</code></pre>
    <Variant platform="ios" api="adobe-callback-with-error" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "swift-19"
    }}>{`Swift`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`MobileCore.getSdkIdentities { (content, error) in
    if let error = error, let aepError = error as? AEPError {
        switch aepError {
        case .unexpected:
          // Handle unexpected error
        case .callbackTimeout:
          // Handle callback timeout error
        case .callbackNil:
          // Handle callback being nil error
        case .none:
          // no error
        case .serverError:
          // handle server error
        case .networkError:
          // handle network error
        case .invalidRequest:
          // handle invalid request error
        case .invalidResponse:
          // handle invalid response error
        case .errorExtensionNotInitialized:
          // handle extension not initialized error
        @unknown default:
          // handle unknown error
        }
    }
    ...
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-19"
    }}>{`Objective-C`}</h4>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`[AEPMobileCore getSdkIdentities:^(NSString * _Nullable content, NSError * _Nullable error) {
    if (error) {
        if (error.code == AEPErrorUnexpected) {
          // Handle unexpected error
        } else if (error.code == AEPErrorCallbackTimeout) {
          // Handle callback timeout error
        } else if (error.code == AEPErrorCallbackNil) {
          // Handle callback being nil error
        } else if (error.code == AEPErrorNone) {
          // no error     
        } else if (error.code == AEPErrorServerError) {
          // handle server error
        } else if (error.code == AEPErrorNetworkError) {
          // handle network error
        } else if (error.code == AEPErrorInvalidRequest) {
          // handle invalid request error
        } else if (error.code == AEPErrorInvalidResponse) {
          // handle invalid response error  
        } else if (error.code == AEPErrorErrorExtensionNotInitialized) {
          // handle extension not intialized error  
        }
    }
    ...
}];
`}</code></pre>
    <Variant platform="android" api="adobe-callback-with-error" repeat="6" mdxType="Variant" />
    <h4 {...{
      "id": "java-22"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Syntax`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`public interface AdobeCallbackWithError<T> extends AdobeCallback<T> {
    void fail(final AdobeError error);
}
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`MobileCore.getPrivacyStatus(new AdobeCallbackWithError<MobilePrivacyStatus>() {
  @Override
  public void fail(final AdobeError error) {
    if (error == AdobeError.UNEXPECTED_ERROR) {
      // handle unexpected error
    } else if (error == AdobeError.CALLBACK_TIMEOUT) {
      // handle timeout error
    } else if (error == AdobeError.CALLBACK_NULL) {
      // handle null callback error
    } else if (error == AdobeError.EXTENSION_NOT_INITIALIZED) {
      // handle extension not initialized error
    } else if (error == AdobeError.SERVER_ERROR) {
      // handle server error
    } else if (error == AdobeError.NETWORK_ERROR) {
      // handle network error
    } else if (error == AdobeError.INVALID_REQUEST) {
      // handle invalid request error
    } else if (error == AdobeError.INVALID_RESPONSE) {
      // handle invalid response error
    }
  }

  @Override
  public void call(final MobilePrivacyStatus value) {
    // use MobilePrivacyStatus value
  }
});
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      